module.exports = __webpack_public_path__ + "img/AlbertaHealthServices_Logo.66061bf5.svg";